import { UserRole } from "../Redux";
import _ from "lodash";

export const LocalPermissionsName =
  process.env.REACT_APP_PERMISSION_STORAGE_NAME;

export var UserPermissions = {};

export const UpdatePermissions = (a) => {
  UserPermissions = a;
};

export const checkPermissions = (v) => {
  if (
    v !== UserRole.user &&
    v !== UserRole.admin &&
    v !== UserRole.visitor &&
    v !== UserRole.super
  )
    return true;
  let temp = _.isEmpty(UserPermissions);
  return !temp;
};

export const StorePermissionsLocal = (a, v) => {
  const b = JSON.stringify(a);
  if (v) {
    localStorage.setItem(LocalPermissionsName, b);
  } else {
    sessionStorage.setItem(LocalPermissionsName, b);
  }
};

export const ExportStoredPermissions = () => {
  const b =
    localStorage.getItem(LocalPermissionsName) ||
    sessionStorage.getItem(LocalPermissionsName);
  if (b === null || b === undefined) {
    return {};
  }
  var c = JSON.parse(b);
  return c;
};

export const ExportPermissionsLocal = (v) => {
  if (
    v !== UserRole.user &&
    v !== UserRole.admin &&
    v !== UserRole.visitor &&
    v !== UserRole.super
  )
    return true;
  const b =
    localStorage.getItem(LocalPermissionsName) ||
    sessionStorage.getItem(LocalPermissionsName);
  if (b === null || b === undefined) {
    if (v === UserRole.super) return true;
    return undefined;
  }
  var c = JSON.parse(b);
  UpdatePermissions(c);
  return c;
};

export const DeletePermissionsLocal = () => {
  UpdatePermissions({});
  localStorage.removeItem(LocalPermissionsName);
  sessionStorage.removeItem(LocalPermissionsName);
};
